module.exports = __webpack_public_path__ + "static/media/unlock.0061e04c.svg";